import { render } from "./rechargePayModel.vue?vue&type=template&id=5494e0d4"
import script from "./rechargePayModel.vue?vue&type=script&lang=js"
export * from "./rechargePayModel.vue?vue&type=script&lang=js"

import "./rechargePayModel.vue?vue&type=style&index=0&id=5494e0d4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__